/**
 * WebKit Scroll Synchronization Fix
 *
 * Safari has a race condition where scroll sync listeners aren't active
 * during initial scrollTime application, causing header/body desync.
 */

/**
 * Sync timeline scrollers (for resourceTimeline views)
 * Header and body horizontal scrollers can desync on WebKit
 */
export function syncTimelineScrollers(calendarEl) {
	if (!calendarEl) return;

	const headerScroller = calendarEl.querySelector(
		".fc-scrollgrid-section-header th:nth-child(3) .fc-scroller"
	);
	const bodyScroller = calendarEl.querySelector(
		".fc-scrollgrid-section-body td:nth-child(3) .fc-scroller"
	);

	if (!headerScroller || !bodyScroller) return;

	// Use whichever scroller has the correct position (non-zero)
	const targetScrollLeft =
		headerScroller.scrollLeft || bodyScroller.scrollLeft;

	if (targetScrollLeft === 0) return;

	// Sync both scrollers to the target position
	bodyScroller.scrollLeft = targetScrollLeft;
	headerScroller.scrollLeft = targetScrollLeft;
}

/**
 * Sync time grid scrollers (for timeGridDay/timeGridWeek views)
 * Header (time labels) and body (events) can desync on WebKit
 */
export function syncTimeGridScrollers(calendarEl) {
	if (!calendarEl) return;

	const timeGridScroller = calendarEl.querySelector(
		".fc-timegrid-body .fc-scroller"
	);
	const headerScroller = calendarEl.querySelector(
		".fc-scrollgrid-section-header .fc-scroller"
	);

	if (!timeGridScroller || !headerScroller) return;

	const targetScrollLeft =
		headerScroller.scrollLeft || timeGridScroller.scrollLeft;

	if (targetScrollLeft > 0) {
		timeGridScroller.scrollLeft = targetScrollLeft;
		headerScroller.scrollLeft = targetScrollLeft;
	}
}
